module.exports = __webpack_public_path__ + "static/media/study 210528.f2f63d87.png";